import React from 'react';

function Modal({ isOpen, onClose, onConfirm, isLoading = false }) {
  if (!isOpen) return null;

  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: 'block' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-gray-500">
            <h5 className="modal-title text-lg fw-bold text-gray-900">Save File</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} disabled={isLoading}></button>
          </div>
          <div className="modal-body">
            <p className="text-sm text-gray-500">Do you want to save this file?</p>
          </div>
          <div className="modal-footer bg-light">
            {/* Yes button */}
            <button type="button" className="btn btn-success" onClick={onConfirm} disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Saving...
                </>
              ) : (
                'Yes'
              )}
            </button>
            {/* No button */}
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={isLoading}>
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
